export default __webpack_public_path__ + "static/media/female.72ee240c.svg";